module.exports = __webpack_public_path__ + "static/img/continue@2x.ebb30ae2.png";